// @ts-nocheck
import { forwardRef, useCallback, useState, useRef, useEffect } from 'react';
import { Card, Box, IconButton, Typography, useTheme } from '@mui/material';
import { capitalize } from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import SuccessIcon from '@mui/icons-material/FileDownloadDone';
import PendingIcon from '@mui/icons-material/Autorenew';
import PartialIcon from '@mui/icons-material/HourglassBottom';
import PropTypes from 'prop-types';
import { SnackbarContent, useSnackbar } from 'notistack';

import AutomationResultModal from '../ModelInventory/Dashboard/MyTasks/AutomationResultModal';

const SSE_TIMER = 10000; // 10 sec

const genStatus = (status, theme) => {
  const baseStyle = {
    color: 'white',
    fontSize: '20px',
    borderRadius: '50%',
    padding: '1px',
  };
  const statusMessage = status?.toLowerCase();
  if (statusMessage === 'success') {
    return (
      <SuccessIcon
        sx={{
          ...baseStyle,
          backgroundColor: `${theme?.palette?.sseNotification?.successIconColor}`,
        }}
      />
    );
  } else if (statusMessage === 'partial') {
    return (
      <PartialIcon
        sx={{
          ...baseStyle,
          backgroundColor: `${theme?.palette?.sseNotification?.partialIconColor}`,
        }}
      />
    );
  } else if (statusMessage === 'failed') {
    return (
      <CloseIcon
        sx={{
          ...baseStyle,
          backgroundColor: `${theme?.palette?.sseNotification?.failedIconColor}`,
        }}
      />
    );
  } else {
    return (
      <PendingIcon
        sx={{
          ...baseStyle,
          backgroundColor: `${theme?.palette?.sseNotification?.pendingIconColor}`,
        }}
      />
    );
  }
};

const AutomationReportToast = forwardRef(
  function AutomationReportToast(props, ref) {
    const { id, message } = props;
    const [open, setOpen] = useState(false);
    const isModalOpenRef = useRef(false);
    const { closeSnackbar } = useSnackbar();
    const theme = useTheme();

    const data = JSON.parse(message);

    const handleDismiss = useCallback(() => {
      setOpen(false);
      isModalOpenRef.current = false;
      closeSnackbar(id);
    }, [setOpen, closeSnackbar, id]);

    const handleViewDetails = useCallback(() => {
      setOpen(true);
      isModalOpenRef.current = true;
    }, [setOpen]);

    useEffect(() => {
      const timeout = setTimeout(() => {
        if (!isModalOpenRef.current) {
          closeSnackbar(id);
        }
      }, SSE_TIMER);

      return () => clearTimeout(timeout);
    }, [closeSnackbar, id]);

    return (
      <>
        <SnackbarContent ref={ref}>
          <Card
            sx={{
              boxShadow: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'start',
              width: '300px',
              padding: '15px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'start',
                gap: '15px',
              }}
            >
              {genStatus(data?.event_status, theme)}
              <Box display="flex" flexDirection="column" gap="15px">
                <Typography variant="body6">
                  {capitalize(data?.event_type)}: {data?.execution_status}
                </Typography>
                <Box
                  className="infoTextStyle"
                  component="button"
                  onClick={handleViewDetails}
                  sx={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    font: 'inherit',
                    textAlign: 'left',
                  }}
                >
                  view details
                </Box>
              </Box>
            </Box>
            <IconButton size="small" onClick={handleDismiss}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Card>
        </SnackbarContent>
        {open && (
          <AutomationResultModal
            handleClose={handleDismiss}
            open={open}
            taskResult={{ result: data?.events_data?.result_data }}
          />
        )}
      </>
    );
  }
);

AutomationReportToast.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  message: PropTypes.string.isRequired,
};

export default AutomationReportToast;
